import { TemplateIcon } from '@heroicons/react/outline';
import { TextTooltip, ToggleButton } from '@showroomjs/ui';
import * as React from 'react';
export const MeasuringButton = (props) => (React.createElement(TextTooltip, { label: "Measure" },
    React.createElement(ToggleButton, { pressed: props.isActive, onPressedChange: props.onClick, css: Object.assign({ border: 0 }, (props.isActive
            ? {
                shadow: 'inner',
                borderRadius: '$sm',
                backgroundColor: '$gray-200',
                color: '$gray-700',
            }
            : {
                backgroundColor: 'inherit',
                color: '$gray-400',
            })), "aria-label": "Measure" },
        React.createElement(TemplateIcon, { width: 20, height: 20 }))));
//# sourceMappingURL=measuring-button.js.map